import { TTerminal } from 'modules/terminal/types'
import {
  OrderCreateCargo,
  OrderCreateCargoTotal,
  OrderCreateCustomer,
  OrderCreatePayer,
  OrderCreateRequest,
  OrderItemClient
} from 'schema'

import { OrderCreateOperationForm } from '../components/OrderCreatePointOperation/types'
import { TOrderCargo, TOrderCargoTotal, TOrderCompany, TOrderContact } from './index'

export const RadioSwitchValue = {
  yes: 'yes',
  no: 'no'
} as const

export type TOrderCreatePayload = OrderCreateRequest

export type TOrderCreateCargoForm = OrderCreateCargo & {
  customHeight: number
  customLength: number
  customWeight: number
  customWidth: number
  palletHeight: number
  palletLength: number
  palletWeight: number
  palletWidth: number
}

export type TOrderCreateCustomer = {
  type: OrderItemClient.type
  company?: TOrderCompany
  customerId?: string
  hasSpecialCargoLimits?: boolean
}

export type TOrderCreatePayer = {
  role: OrderCreatePayer.Role | undefined
  // только для фронта
  company?: {
    inn: string
    kpp: string
    name: string
  }
  // только для фронта
  contact?: {
    name: string
    phone: string
    phoneExt: string | undefined
  }
  type?: OrderItemClient.type | undefined
}

export type TOrderCreatePartner = {
  contactId: string | undefined
  isUser: boolean
  type: OrderItemClient.type | undefined
  // только для фронта
  company?: TOrderCompany
  companyId?: string | undefined
  // только для фронта
  contact?: TOrderContact
}

export type TOrderCreatePoint = {
  isCourier: boolean
  terminalId: string
  addressDetail?: {
    address: string
    latitude: string
    longitude: string
    comment?: string
    fiasId?: string
  }
} & { terminal: TTerminal }

export type TOrderCreateCargo = TOrderCargo

export type TOrderCreateCargoTotal = TOrderCargoTotal

export type TOrderCreatePartnerFormData = Omit<TOrderCreatePartner, 'isUser'> & {
  isUser: Values<typeof RadioSwitchValue>
}

export type TOrderCustomerFormData = OrderCreateCustomer & {
  hasSpecialCargoLimits?: boolean
}

export type TOrderCreateFormData = Partial<{
  cargo: TOrderCreateCargoForm[]
  cargoTotal: OrderCreateCargoTotal
  cargoType: OrderCreateRequest.cargoType
  comment: string
  customer: TOrderCustomerFormData
  departureDate: string
  departurePartner: TOrderCreatePartnerFormData
  departurePoint: TOrderCreatePoint
  destinationPartner: TOrderCreatePartnerFormData
  destinationPoint: TOrderCreatePoint
  isAgreeOffer: boolean
  operation: OrderCreateOperationForm[]
  payer: TOrderCreatePayer
}>
